import AssetDetailView from './AssetDetailView';
export default { AssetDetailView };
